import React from "react";
import { Footer } from "./footer";
import { WeatherInfo } from "./weatherInfo";
import { Header } from "./header";

function App() {
  return (
    <>
      <Header />
      <WeatherInfo />
      <Footer />
    </>
  );
}

export default App;
